export const DEFAULT_REQUEST_TYPE_ICON = 'fas fa-clipboard-list';

export const REQUEST_TYPE_ICON_OPTIONS = [
    { value: 'fas fa-clipboard-list', text: 'Общая заявка' },
    { value: 'fas fa-boxes', text: 'Материалы' },
    { value: 'fas fa-hard-hat', text: 'Работы' },
    { value: 'fas fa-tools', text: 'Ремонт' },
    { value: 'fas fa-truck', text: 'Доставка' },
    { value: 'fas fa-gas-pump', text: 'Топливо / заправка' },
    { value: 'fas fa-credit-card', text: 'Топливная карта' },
    { value: 'fas fa-oil-can', text: 'ГСМ / масло' },
    { value: 'fas fa-receipt', text: 'Чеки по топливу' },
    { value: 'fas fa-route', text: 'Маршрут / перемещение' },
    { value: 'fas fa-laptop', text: 'ИТ' },
    { value: 'fas fa-wallet', text: 'Финансы' },
    { value: 'fas fa-file-alt', text: 'Документы' },
    { value: 'fas fa-users', text: 'Сотрудники' },
    { value: 'fas fa-user-shield', text: 'Доступы' },
    { value: 'fas fa-building', text: 'Административная' },
    { value: 'fas fa-exclamation-triangle', text: 'Срочная' }
];

export function normalizeRequestTypeIcon(icon) {
    const value = String(icon || '').trim();
    return REQUEST_TYPE_ICON_OPTIONS.some(option => option.value === value)
        ? value
        : DEFAULT_REQUEST_TYPE_ICON;
}
